<template>
  <b-offcanvas placement="start" title="iSales menu" id="isales-sidebar" ref="offcanvas">
    <b-list-group>
      <b-list-group-item :to="{ name: 'Home' }" v-if="showRoute('Home')" exact-active-class="active">
        Home
      </b-list-group-item>
      <b-list-group-item
        :to="{ name: 'ClientiRicerca' }"
        v-if="showRoute('ClientiRicerca')"
        exact-active-class="active"
      >
        Clienti
      </b-list-group-item>
      <span v-if="showRoute('Ordine')">
        <b-list-group-item
          v-for="tipoOrdine in IMPOSTAZIONI_TIPI_DOCUMENTO"
          :key="tipoOrdine.IdDoc"
          :to="{ name: 'Ordine', params: { idDoc: tipoOrdine.IdDoc } }"
          exact-active-class="active"
        >
          {{ tipoOrdine.Label }}
        </b-list-group-item>
      </span>
      <b-list-group-item :to="{ name: 'StoricoOrdini' }" v-if="showRoute('StoricoOrdini')" exact-active-class="active">
        Storico Ordini
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'StoricoFatture' }" v-if="showRoute('StoricoFatture')" exact-active-class="active">
        Storico Fatture
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Login' }" exact-active-class="active">
        <span v-if="isAuthenticated"> Cambia utente </span>
        <span v-else> Login </span>
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Pagamenti' }" v-if="showRoute('Pagamenti')" exact-active-class="active">
        Pagamenti
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Incassi' }" v-if="showRoute('Incassi')" exact-active-class="active">
        Incassi
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Sales'}" v-if="showRoute('Sales')" exact-active-class="active">
        Statistiche
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'DatiVendita' }" v-if="showRoute('DatiVendita')" exact-active-class="active">
        Dati Vendita
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Changelog' }" v-if="showRoute('Changelog')" exact-active-class="active">
        Changelog
      </b-list-group-item>
      <b-list-group-item :to="{ name: 'Reset' }" exact-active-class="active"> Reset </b-list-group-item>
    </b-list-group>
  </b-offcanvas>
</template>

<style lang="scss">
#isales-sidebar .offcanvas-body {
  padding: 0;

  .list-group {
    border-radius: 0;
  }
}
</style>

<script lang="ts">
import { useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import type { Offcanvas } from "bootstrap";

import { indexArray } from "@/utils";
import { useCustomerStore } from "@/stores/customers";
import { useRootStore } from "@/stores/root";
import { useSettingsStore } from "@/stores/settings";
import { isFunction } from "lodash";

export default {
  setup() {
    const offcanvas = ref<Offcanvas | null>(null);
    const customerStore = useCustomerStore();
    const rootStore = useRootStore();
    const settingStore = useSettingsStore();
    const router = useRouter();
    const data = {
      routers: ref(indexArray(router.getRoutes(), "name")),
    };
    onMounted(() => {
      //const el = offcanvas.value?.$el as HTMLElement;
      //offcanvas.value = new Offcanvas();
    });
    const computed_ = {
      CUSTOMERS_selected: computed(() => customerStore.CUSTOMERS_selected),
      isAuthenticated: computed(() => rootStore.isAuthenticated),
      IMPOSTAZIONI_TIPI_DOCUMENTO: computed(() => settingStore.IMPOSTAZIONI_TIPI_DOCUMENTO_get),
    };
    const actions = {
      showRoute(routeName: string) {
        const targetRoute = data.routers.value[routeName];
        if (!targetRoute) {
          console.error(`[SiteSidebar] invalid route`, routeName);
          return false;
        }
        if (targetRoute.meta.requiresAuth && !computed_.isAuthenticated.value) {
          return false;
        }
        if (targetRoute.meta.requiresCustomer && !computed_.CUSTOMERS_selected.value) {
          return false;
        }
        if (isFunction(targetRoute.meta.show) && !targetRoute.meta.show()) {
          return false;
        }
        return true;
      },
    };
    router.beforeEach(() => {
      offcanvas.value?.hide();
    });
    return { ...data, ...actions, ...computed_, offcanvas };
  },
};
</script>
